import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfirmarCorreoService {

  API_URL: string = environment.API_URL;

  constructor(
    private http: HttpClient
  ) { }

  checkIdentificador(identificador: string): Observable<any> {
    let API_URL = `${this.API_URL}/confirmar_correo/check_identificador`;
    return this.http.post(API_URL, identificador)
  }

  reenviarCorreo(identificador: string): Observable<any> {
    let API_URL = `${this.API_URL}/confirmar_correo/resend_confirmation_email`;
    return this.http.post(API_URL, identificador)
  }

  getEmailConfirmacion(email: string): Observable<any> {
    let API_URL = `${this.API_URL}/confirmar_correo/get_email_confirmacion/` + email;
    return this.http.get(API_URL)
  }
}
